var map = {
	"./cap-hinten.png": 791,
	"./cap-seite.png": 8509,
	"./cap.png": 1830,
	"./deckel-narrenbecher.png": 7998,
	"./fleecejacke-hinten.png": 5457,
	"./fleecejacke.png": 6980,
	"./handschweif-hell.png": 7798,
	"./handschweif.png": 6556,
	"./hoodie-hinten.png": 5953,
	"./hoodie.png": 5060,
	"./jacke-hinten.png": 8461,
	"./jacke.png": 3424,
	"./kindermaske.png": 3778,
	"./longsleeve-hinten.png": 8631,
	"./longsleeve.png": 1206,
	"./maske.png": 2155,
	"./maskentuch.png": 6697,
	"./muetze-hinten.png": 7679,
	"./muetze.png": 3582,
	"./narrenbecher-gravur-hinten.png": 8860,
	"./narrenbecher-gravur.png": 1707,
	"./nummer-maskentuch.png": 54,
	"./product-placeholder.svg": 9863,
	"./pullover-hinten.png": 6124,
	"./pullover.png": 5707,
	"./pumphose-detail-reissverschluss.png": 1582,
	"./pumphose-hinten.png": 2862,
	"./pumphose.png": 113,
	"./rock.png": 9259,
	"./schlauchschaal-hinten.png": 358,
	"./schlauchschaal.png": 3593,
	"./schnapsbecher.png": 8815,
	"./schuerze-detail.png": 3,
	"./schuerze.png": 1121,
	"./schweif-maske-rot.png": 4859,
	"./schweif-maske.png": 5935,
	"./second-hand-placeholder.png": 7012,
	"./shop-herobanner.png": 3502,
	"./socken.png": 4761,
	"./stoff-braun-schuerze.png": 9573,
	"./stoff-gruen-maskentuch.png": 7426,
	"./stoff-gruen-rock.png": 6088,
	"./stoffrucksack.png": 5433,
	"./strohschuhe.png": 6016,
	"./top-hinten.png": 1348,
	"./top.png": 7299,
	"./tshirt-hinten.png": 8053,
	"./tshirt-v-ausschnitt.png": 1482,
	"./tshirt.png": 9688,
	"./wappen-eckenmoorhexen.png": 2461,
	"./zipper-hinten.png": 6343,
	"./zipper.png": 886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5290;